import {ModuleWithProviders, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TokensService } from './services/tokens.service';
import {AuthService} from '@auth-suite-services/services';
import {Environment} from './model/environment';
import {ConfigService} from './services/config.service';

@NgModule({
  imports: [CommonModule]
})
export class SuredebitSetupModule {
  static forRoot(config: Environment): ModuleWithProviders<SuredebitSetupModule> {
    return {
      ngModule: SuredebitSetupModule,
      providers: [
        AuthService,
        {
          provide: ConfigService,
          useValue: config
        },
        TokensService
      ]
    };
  }
}
